import Vue from 'vue'

export default {
  setCm24Setting (state, cm24Settings) {
    const key = cm24Settings.key

    Vue.set(state.settings, key, cm24Settings)
  }

}
